import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

export default function OFECxLookahead() {
  const { user } = useAuth();
  const [project, setProject] = useState('');
  const { data: milestones, loading: mlLoading } = useOFEFetch('/ofe/cx/milestones', user);
  const { data: lookahead } = useOFEFetch(project ? `/ofe/cx/lookahead/${project}` : null, user, [project]);

  const projects = [...new Set((milestones || []).map(m => m.project_allocation))];

  const STATUS_COLORS = {
    pending: 'bg-gray-700 text-gray-300',
    in_progress: 'bg-blue-900/40 text-blue-300',
    complete: 'bg-green-900/40 text-green-300',
    at_risk: 'bg-yellow-900/40 text-yellow-400',
    blocked: 'bg-red-900/40 text-red-400',
  };

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-bold text-white">Cx Look-Ahead</h1>
        <Link to="/ofe/cx/issues" className="ml-auto bg-red-800 hover:bg-red-700 text-white px-3 py-1.5 rounded text-sm">View Issues →</Link>
      </div>

      <select value={project} onChange={e => setProject(e.target.value)}
        className="bg-gray-800 border border-gray-600 text-white px-3 py-2 rounded text-sm w-64">
        <option value="">Select project...</option>
        {projects.map(p => <option key={p} value={p}>{p}</option>)}
      </select>

      {lookahead && (
        <div className="grid grid-cols-4 gap-3">
          {[
            { label: 'Upcoming Milestones', value: lookahead.upcoming_milestones?.length, color: 'text-blue-400' },
            { label: 'Open Issues', value: lookahead.open_issues, color: 'text-yellow-400' },
            { label: 'Critical Issues', value: lookahead.critical_issues, color: 'text-red-400' },
            { label: 'Docs Pending', value: lookahead.closeout_docs_pending, color: 'text-orange-400' },
          ].map(m => (
            <div key={m.label} className="bg-gray-800 border border-gray-700 rounded p-3">
              <div className={`text-2xl font-bold ${m.color}`}>{m.value}</div>
              <div className="text-gray-400 text-xs mt-1">{m.label}</div>
            </div>
          ))}
        </div>
      )}

      {mlLoading && <div className="text-gray-400">Loading...</div>}

      <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-900 text-gray-400">
            <tr><th className="text-left px-4 py-3">Project</th><th className="text-left px-4 py-3">Milestone</th><th className="text-left px-4 py-3">Type</th><th className="text-left px-4 py-3">Target</th><th className="text-left px-4 py-3">Status</th></tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {(milestones || []).filter(m => !project || m.project_allocation === project).map(m => (
              <tr key={m.id} className="hover:bg-gray-750">
                <td className="px-4 py-2 font-mono text-blue-400 text-xs">{m.project_allocation}</td>
                <td className="px-4 py-2 text-white">{m.milestone_name}</td>
                <td className="px-4 py-2 text-gray-300 text-xs">{m.milestone_type}</td>
                <td className="px-4 py-2 text-gray-300 text-xs">{m.target_date || '—'}</td>
                <td className="px-4 py-2">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_COLORS[m.status] || 'bg-gray-700 text-gray-300'}`}>{m.status}</span>
                </td>
              </tr>
            ))}
            {!milestones?.length && !mlLoading && <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-500">No milestones</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
